import { ICondition } from '@medely/types';
import {
  useCurrentUser,
  useNearFutureExpiringConditions,
  useProfessionalQualifications,
} from '@mp/hooks';
import {
  getMissingConditionStatus,
  MissingConditionStatus,
} from '@mp/utils/missingConditionStatus';
import { useRecommendedCredentialsJobCounts } from './useRecommendedCredentialsJobCounts';

const COUNTED_STATUSES = [
  MissingConditionStatus.Missing,
  MissingConditionStatus.NeedsAttention,
  MissingConditionStatus.Expired,
];

export const useRecommendedTabCount = (): number => {
  const { isEnabled, conditions } = useRecommendedCredentialsJobCounts();
  const { currentUser } = useCurrentUser();
  const { allProfessionalQualifications } = useProfessionalQualifications();
  const { expiringConditions } = useNearFutureExpiringConditions();

  if (!isEnabled) {
    return 0;
  }

  const satisfiedConditionIds = currentUser?.professional?.satisfied_condition_ids ?? [];
  const expiringConditionIds = expiringConditions.map(({ id }) => id);

  return conditions.filter(({ condition }) =>
    COUNTED_STATUSES.includes(
      getMissingConditionStatus({
        condition: condition as ICondition,
        professionalQualifications: allProfessionalQualifications,
        satisfiedConditionIds,
        expiringConditionIds,
      }),
    ),
  ).length;
};
